import { useCallback, useEffect, useState } from 'react';

import { IDeathLocation } from '../../models/IDeathLocation';

import { DeathLocationHook } from './types';
import { getDeathLocations } from 'actions/masterData';

export const useDeathLocation = (cityCode?: string): DeathLocationHook => {
  const [items, setItems] = useState<IDeathLocation[]>([]);

  const fetchDeathLocations = async (code: string) => getDeathLocations(code)
    .then((response) => {
      setItems(response.data as IDeathLocation[]);
      return response.data;
    })
    .catch(() => {
      setItems([]);
    });

  const getDeathLocation = async () => {
    await getDeathLocations(cityCode)
      .then((response) => {
        setItems(response.data as IDeathLocation[]);
        return response.data;
      })
      .catch(() => {
        setItems([]);
      });
  };

  useEffect(() => {
    getDeathLocation();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cityCode]);

  const getDeathLocationByCode = useCallback(
    (code?: string) => (items.find((item) => item.code === code)),
    [items],
  );

  return {
    deathLocations: items,
    fetchDeathLocations,
    getDeathLocationByCode,
  };
};
